
<div style="height: 100%;">
  <!-- <router-outlet ></router-outlet> -->
  <router-outlet *ngIf="isRouterView"></router-outlet>
</div>  